require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-a-software-interview-challenge.json") })
        }
      }, "path---posts-a-software-interview-challenge");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-a-software-interview-challenge!./.cache/json/posts-a-software-interview-challenge.json
// module id = 367
// module chunks = 231608221292675